import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";

interface IUseDeleteFixedDiscountRulesOptions {
  refundRulesId: number;
}

export function useDeleteFixedDiscountRules() {
    const { request } = usePbm2Url();
    return useMutation('deleteRefundRule', async (variables: IUseDeleteFixedDiscountRulesOptions) => {
      const { Refund_deleteRefundRule } = await request(
        gql`
        mutation($input: Refund_DeleteRefundRules!) {
          Refund_deleteRefundRule(input: $input)
          }
        `,
        {
          input: {
            refundRulesId: variables?.refundRulesId,
          } as IUseDeleteFixedDiscountRulesOptions,
        }
      );
      return Refund_deleteRefundRule;
    });
  }